
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { useAuth } from '@/context/AuthContext';
import { useEffect } from 'react';
import { useRoleMapping } from '@/hooks/useRoleMapping';

const Unauthorized = () => {
  const { profile } = useAuth();
  const { isIndividual, isCorporate, isAdmin } = useRoleMapping();
  const navigate = useNavigate();

  // Rediriger automatiquement l'utilisateur s'il a un profil
  useEffect(() => {
    if (profile) {
      // Redirection basée sur le rôle
      if (isIndividual) {
        navigate('/request-candidate-feedback');
      } else if (isCorporate) {
        navigate('/request-recruiter-feedback');
      } else if (isAdmin) {
        navigate('/admin');
      } else {
        // Valeur par défaut si le rôle n'est pas reconnu
        navigate('/dashboard');
      }
    }
  }, [profile, isIndividual, isCorporate, isAdmin, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4 text-center">
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-red-500 mb-4">Accès non autorisé</h1>
        <p className="text-lg text-gray-600 max-w-md mx-auto mb-8">
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        </p>
        <div className="space-y-4">
          <Button asChild>
            <Link to="/dashboard">Retour au tableau de bord</Link>
          </Button>
          <div className="block mt-4">
            <Link to="/" className="text-brandBlue hover:underline">
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
